import { render, staticRenderFns } from "./shenqing.vue?vue&type=template&id=0b734fe2&scoped=true&"
import script from "./shenqing.vue?vue&type=script&lang=js&"
export * from "./shenqing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b734fe2",
  null
  
)

export default component.exports